<script>
    import { Bar } from 'vue-chartjs'
    import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

    export default {
        extends: Bar,
        props:['items', 'type'],
        mounted () {
            this.rerender()
        },
        /**
         * archive_count: 0
         event_count: 2
         event_date: "2019-11-05T15:00:00+00:00"
         final_count: 0
         progress_count: 2
         */
        methods: {
            rerender() {
                let labels = [],
                    event_count = [],
                    archive_count = [],
                    final_count = [],
                    progress_count = []
                ;
                this.items.forEach((item) => {
                    if(this.type === 'admin') {
                        labels.push(item.region);
                    } else {
                        labels.push(item.user);
                    }
                    event_count.push(item.event_count)
                    archive_count.push(item.archive_count)
                    final_count.push(item.final_count)
                    progress_count.push(item.progress_count)
                });

                // Overwriting base render method with actual data.
                this.renderChart(
                    {
                        labels: labels,
                        datasets: [
                            {
                                label: 'Число участников инф. мероприятия (в CRM)',
                                backgroundColor: '#ffc107',
                                data: event_count
                            },
                            {
                                label: 'Завершили диагностику',
                                backgroundColor: '#4dbd74',
                                data: final_count
                            },
                            {
                                label: 'Архив',
                                backgroundColor: '#f5302e',
                                data: archive_count
                            },
                            {
                                label: 'В процессе диагностики',
                                backgroundColor: '#2eadd3',
                                data: progress_count
                            }
                        ]
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips,
                            intersect: true,
                            mode: 'index',
                            position: 'nearest',
                            callbacks: {
                                labelColor: function (tooltipItem, chart) {
                                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
                                }
                            }
                        }
                    }
                )
            }
        },
        watch: {
            items: function() {
                this.rerender();
            }
        }
    }
</script>
